//
// ページの状態管理
//
export default {
  state: {
    ready: false,
    waits: [],
    errors: []
  },

  getters: {
    stateReady (state) {
      return state.ready && state.waits.length === 0
    },

    stateErrors (state) {
      return state.errors
    }
  },

  mutations: {
    stateInit (state) {
      state.ready = false
      state.waits = []
      state.errors = []
    },

    stateReady (state) {
      state.ready = true
    },

    stateWaits (state, waits) {
      state.waits = waits
    },

    statePrepared (state, name) {
      const idx = state.waits.indexOf(name)
      if (idx >= 0) {
        state.waits.splice(idx, 1)
      }
    },

    stateAddErrors (state, errors) {
      if (typeof errors === 'string') {
        errors = [errors]
      } else if (!Array.isArray(errors)) {
        return
      }
      state.errors.push(...errors)
    }
  }
}
